import { type IQuestionBase, type IQuestion } from "features/Library/Common/models";
import { type QuestionPropsBase } from "features/Library/Common/QuestionsForm/types";

interface QuestionToRenderPayload<T> {
  Component: (props: QuestionPropsBase<T>) => React.ReactElement;
  castQuestion: (Question: IQuestionBase) => IQuestion<T>;
}

type QuestionsMapType<T> = {
  [K in keyof T]: QuestionToRenderPayload<T[K]>;
};

export const asQuestionsMap = <TType, TValue>(map: TValue & QuestionsMapType<TType>): TValue => {
  return map;
};
